import React, { useEffect, useState } from "react";

import SwalAlert from "../../../../../../services/swalService/SwalService";
import ToastService from "../../../../../../services/toastService/ToastService";
import { getFileIcon } from "../../../../../../lib/getFileIcon";
import IconButton from "../../../../../../components/ui/iconbutton/IconButton";
import Iconify from "../../../../../../layouts/components/iconify/iconify";
import NoRecordFound from "../../../../../../components/ui/noRecordFound/NoRecordFound";
import CenterModel from "../../../../../../components/ui/centerModel/CenterModel";
import AddAttachments from "../../../../../task/attachments/features/AddAttachments ";

import "./NewTaskAttachments.scss";
import { useDeleteTaskAttachmentMutation, useLazyGetDownloadFileQuery, useLazyGetalltaskattachmentQuery } from "../../../../../../app/services/taskattachmentAPI";

const NewTaskAttachments = ({taskId,projectId}) => {

  const [isModelOpen, setisModelOpen] = useState(false);


  const { confirm } = SwalAlert();

  const [getalltaskattachment, {
    isLoading: isTaskAttachmentListLoading,
    isSuccess: isTaskAttachmentSuccess,
    data: isTaskAttachmentListData,
  },] = useLazyGetalltaskattachmentQuery();

  const [deleteTaskAttachment, {
    isSuccess: isDeleteSucess,
    data: isDeleteData
  },] = useDeleteTaskAttachmentMutation();

  const [getDownloadFile, {
    isLoading: isDownalodFetching,
    isSuccess: isDownalodSucess,
    data: isDownalodData,
  },] = useLazyGetDownloadFileQuery();

  const [attachmentsData, setattachmentsData] = useState([]);
  const [downloadFileName, setDownloadFileName] = useState();

  useEffect(() => {
    if (
      isTaskAttachmentSuccess &&
      !isTaskAttachmentListLoading &&
      isTaskAttachmentListData
    ) {
      const attachmentPaths = isTaskAttachmentListData.map((attachment) => ({
        id: attachment.taskAttachmentId,
        name: attachment.attachmentPath,
        type: attachment.attachmentType,
      }));

      setattachmentsData(attachmentPaths);
    }
  }, [
    isTaskAttachmentSuccess,
    isTaskAttachmentListLoading,
    isTaskAttachmentListData,
  ]);

  useEffect(() => {
    if (taskId && projectId) {
      getalltaskattachment({ taskId, projectId });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  const handleDelete = (attachmentId, index) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteTaskAttachment(attachmentId);
        setattachmentsData((prevFiles) =>
          prevFiles.filter((_, i) => i !== index)
        );
      }
    });
  };

  useEffect(() => {
    if (!isDownalodFetching && isDownalodSucess && isDownalodData) {
      if (isDownalodData.blobUrl && isDownalodData.contentType) {
        const fileURL = isDownalodData.blobUrl;
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = downloadFileName;
        document.body.appendChild(link);
        link.click();
        link.remove();

        URL.revokeObjectURL(fileURL);
      }
    }
  }, [isDownalodFetching, isDownalodSucess, isDownalodData, downloadFileName]);

  const handaldownload = (filename) => {
    getDownloadFile(filename);
    setDownloadFileName(filename);
  };

  const AddhandleToggleModal = () => {
    setisModelOpen(!isModelOpen);
  };

  const onClose = () => {
    setisModelOpen(false);
    getalltaskattachment({ taskId, projectId });
  };

  useEffect(() => {
    if (isDeleteSucess && isDeleteData) {
      ToastService.success(isDeleteData.errorMessage);
      getalltaskattachment({ taskId, projectId });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteSucess && isDeleteData]);

  return (
    <>
      <div className="newattachments-container">
        <div className="task-title-sec">
          <div className="taskdetail-attachments-label">Tasks Attachments :</div>
          {/* <Buttons
            buttonTypeClassName={"theme-btn"}
            onClick={AddhandleToggleModal}
            buttonText={"Attachments"}
            textWithIcon={true}
            fontIcon={true}
            iconName={"ic:round-add"}
            titleText={"Add"}
          /> */}
          <IconButton size="small" icon="ic:round-add" shape="square" onClick={AddhandleToggleModal} />
        </div>
        <div className="row attachments-gutter">
          {attachmentsData && attachmentsData.length > 0 ? (
            attachmentsData.map((file, index) => (
              <div className="col-6" key={index + 1}>
                <div className="attachment-item">
                  <div className="file-info">
                    <div className="file-assets">
                      <img
                        src={getFileIcon(file.type)}
                        alt=""
                        className="file-icon"
                      />
                    </div>
                    <div className="file-details">
                      <span className="file-name">{file.name}</span>
                    </div>
                  </div>
                  <div className="file-actions">
                    <button
                      className="download-btn"
                      onClick={() => handaldownload(file.name)}
                    >
                      <Iconify icon="material-symbols:download" />
                    </button>

                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(file.id, index)}
                    >
                      <Iconify icon="mingcute:delete-2-line" />
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-data-found">
              <NoRecordFound message="No Attachment" />
            </div>
          )}
        </div>
      </div>
      <div>
        {isModelOpen && (
          <CenterModel
            showModal={isModelOpen}
            handleToggleModal={onClose}
            modalTitle={"Add Task Attachments"}
            modelSizeClass="w-40"
          >
            <AddAttachments
              onClose={onClose}
              taskId={taskId}
              projectId={projectId}
            />
          </CenterModel>
        )}
      </div>
    </>
  );
};

export default NewTaskAttachments;
